import React, { useState } from "react"
import Image from "../components/image"
import menuData from "../data/menu.json"
import findObject from "../helpers/find-object"
import { Link } from "gatsby"
import Arrow from "../images/arrow.inline.svg"
import VisibilitySensor from "react-visibility-sensor"

export default function ReadNext({ sectionID, pageID }) {
  const [loaded, setLoaded] = useState(false)
  const onChange = isVisible => {
    isVisible ? setLoaded(true) : setLoaded(false)
  }

  const menu = findObject(menuData, "id", sectionID)
  const content =
    menu && pageID ? findObject(menu.children, "id", pageID) : menu

  const { href, thumbnail, name, deck } = content

  return (
    <VisibilitySensor
      onChange={onChange}
      partialVisibility={true}
      offset={{ bottom: 75 }}
    >
      <Link
        className={`read-next ${
          loaded ? "read-next--show" : "read-next--hidden"
        }`}
        to={href}
      >
        {thumbnail && (
          <Image
            path={thumbnail}
            alt={`Read next: ${name}`}
            className="read-next__image"
          />
        )}
        <div className="read-next__content">
          <div className="read-next__content__inner">
            <header>
              <h2 className="title title--s title--bold title--uppercase">
                Read Next
              </h2>
              <h3 className="title title--m">{name}</h3>
            </header>
            {deck && <p>{deck}</p>}
          </div>
          <div className="read-next__content__arrow">
            <Arrow />
          </div>
        </div>
      </Link>
    </VisibilitySensor>
  )
}
